<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="800px"
      @close="close"
    >
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <el-form-item v-if="form.battleTeamId" label="战队ID" prop="battleTeamId">
          {{ form.battleTeamId }}
        </el-form-item>
        <el-form-item label="游戏" prop="gameId">
          <el-select v-model="form.gameId" placeholder="请选择游戏" class="fix-width" :disabled='!!form.battleTeamId'>
            <el-option
              v-for="item in gameList"
              :key="item.gameId"
              :label="item.title"
              :value="item.gameId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="图片" prop="avatar">
          <el-upload
            :multiple="false"
            :limit="1"
            :class="{ disabled: form.avatar.length > 0 }"
            :action="QNUploadURL"
            :data="uploadToken"
            list-type="picture-card"
            :file-list="form.avatar"
            :on-success="avatar_success"
            :on-remove="avatar_remove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <span>建议尺寸：630px * 200px </span>
        </el-form-item>
        <el-form-item label="备注" prop="text">
          <el-input
            v-model="form.text"
            type="textarea"
            class="fix-width"
            placeholder="请输入备注"
          />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createBattleTeam, updateBattleTeam, findList} from '@/api/game'
import { getUploadToken } from '@/api/app'
import { QNUploadURL, QNHost } from '@/config/net.config'
export default {
  name: 'TeamEdit',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      QNUploadURL,
      QNHost,
      uploadToken: null,
      gameList: [],
      form: {
        battleTeamId: '',
        gameId:'',
        title: '',
        avatar: [],
        text: '',
        order: 1,
      },
      rules: {
        gameId: [{ required: true, trigger: 'blur', message: '请选择游戏' }],
        title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
      },
      dialogFormVisible: false,
    }
  },
  methods: {
    async showEdit(row) {
      if (row) {
        this.title = '修改战队'
        this.form = Object.assign(this.form, row.basic)
        this.form.battleTeamId = row.battleTeamId
        this.form.title = row.title
        this.form.gameId = row.gameId
        this.form.avatar = row.basic.avatar?[{url:row.basic.avatar}]:[]
      } else {
        this.title = '新增战队'
      }
      this.getGameList()
      const token = await getUploadToken({})
      this.uploadToken = { token: token.token }
      this.dialogFormVisible = true
    },
    //获取游戏列表
    async getGameList() {
      const { list } = await findList({page:1,size:10000})
      this.gameList = list
    },
    avatar_remove(file, fileList) {
      this.form.avatar = fileList.map((e) => ({
        name: e.name,
        url: e.url,
      }))
    },
    avatar_success(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.form.avatar.push({
        name: file.name,
        url: QNHost + '/' + res.hash,
      })
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const battleTeamId = this.form.battleTeamId
          //处理图片
          const data = Object.assign({}, this.form)
          const avatar = (data.avatar[0] && data.avatar[0].url) || ''
          data.avatar = avatar
          this.$baseConfirm(
            `你确定要${battleTeamId ? '修改' : '新增'}战队吗`,
            null,
            async () => {
              battleTeamId
                ? await updateBattleTeam(data)
                : await createBattleTeam(data)
              this.$baseMessage(
                `${battleTeamId ? '修改' : '新增'}战队成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss">
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  width: 500px;
}
</style>
